import React, { useState } from 'react';
import { ArrowRight, Ticket, ShieldCheck, CreditCard, X } from 'lucide-react';

const AdRemovalPage: React.FC = () => {
  const [flipped, setFlipped] = useState(false);
  const [showTerms, setShowTerms] = useState(false);

  const handleCheckout = () => {
    setFlipped((prev) => !prev);
  };

  return (
    <div className="fade-in">
      <div className="dashboard-hero-card" style={{ marginBottom: '1rem' }}>
        <div className="dashboard-hero-grid">
          <div className="dashboard-hero-copy">
            <div className="dashboard-page-kicker">광고 제거</div>
            <h1 className="dashboard-hero-title">광고 없이 더 깔끔하게 사용하세요.</h1>
            <p className="dashboard-hero-description">
              광고 제거를 결제하면 서비스 이용 중 광고 노출을 숨길 수 있습니다.
            </p>
          </div>

          <div className="dashboard-hero-stats">
            <div className="dashboard-stat-chip">
              <span>결제 금액</span>
              <strong>9,900원</strong>
            </div>
            <div className="dashboard-stat-chip">
              <span>방식</span>
              <strong>영구</strong>
            </div>
          </div>
        </div>
      </div>

      <div className="dashboard-grid dashboard-grid-clean">
        <section className="card dashboard-main-card">
          <div className="dashboard-card-head">
            <div className="dashboard-card-kicker">
              <Ticket size={14} />
              <span>광고 제거 결제</span>
            </div>
            <h2 className="dashboard-card-title">광고 제거 신청 안내</h2>
          </div>

          <div className={`ad-flip-shell ${flipped ? 'flipped' : ''}`}>
            <div className="ad-flip-card">
              <div className="ad-flip-face ad-flip-front">
              <div className="dashboard-ad-pricing">
                <div className="dashboard-ad-price-box">
                  <div className="dashboard-ad-price-label">광고 제거</div>
                  <div className="dashboard-ad-price-value">9,900원 / 영구</div>
                  <div className="dashboard-ad-price-note">(서비스 종료시까지)</div>
                </div>

                  <div className="dashboard-ad-benefits">
                    <div className="dashboard-ad-benefit">
                      <CreditCard size={18} />
                      <div>
                        <strong>송금 신청</strong>
                        <span>개발자에게 직접 송금하는 방식으로 신청합니다.</span>
                      </div>
                    </div>
                    <div className="dashboard-ad-benefit">
                      <ShieldCheck size={18} />
                      <div>
                        <strong>신청 후 처리</strong>
                        <span>접수 후 광고 제거 기능이 반영됩니다.</span>
                      </div>
                    </div>
                  </div>
                </div>

                <button type="button" className="btn btn-primary dashboard-ad-checkout-btn" onClick={handleCheckout}>
                  광고제거 9900원 결제하기 <ArrowRight size={16} />
                </button>
              </div>

              <div className="ad-flip-face ad-flip-back">
                <div className="ad-removal-back-note">
                  <div className="dashboard-card-kicker" style={{ marginBottom: '0.75rem' }}>
                    <Ticket size={14} />
                    <span>신청 안내</span>
                  </div>
                  <p className="ad-removal-back-copy">
                    개발자에게 송금을 통해 광고 제거를 신청하실 수 있습니다.
                    최대 24시간 이내로 광고 제거 기능이 수행됩니다.
                  </p>
                  <div className="ad-removal-bank-box">
                    <div className="ad-removal-bank-line">신한은행 윤준석 110-218-986002</div>
                    <div className="ad-removal-bank-line">입금 메모는 반드시 사용자명으로 해주세요.</div>
                  </div>
                  <div className="ad-removal-help">
                    24시간 이내 미승인시 wicaduce@gmail.com으로 문의메일 발송해주시면 응대해드리겠습니다.
                  </div>
                </div>

                <button type="button" className="btn btn-outline dashboard-ad-checkout-btn" onClick={handleCheckout}>
                  다시 보기 <ArrowRight size={16} />
                </button>

                <button type="button" className="dsm-link-btn dsm-link-btn-strong" onClick={() => setShowTerms(true)}>
                  결제 약관 보기
                </button>
              </div>
            </div>
          </div>
        </section>

        <aside className="dashboard-side-stack">
          <section className="card dashboard-side-card">
            <div className="dashboard-card-kicker">
              <Ticket size={14} />
              <span>이용 안내</span>
            </div>
            <p className="dashboard-card-copy" style={{ marginBottom: 0 }}>
              신청 내용을 확인한 뒤 안내에 따라 송금해 주세요.
            </p>
          </section>
        </aside>
      </div>

      {showTerms && (
        <div className="modal-overlay">
          <div className="modal-content ad-terms-modal">
            <div className="ad-terms-hero">
              <div className="ad-terms-hero-head">
                <div className="dashboard-card-kicker" style={{ marginBottom: '0.7rem' }}>
                  <Ticket size={14} />
                  <span>결제 약관</span>
                </div>
                <button type="button" className="btn btn-outline ad-terms-close" onClick={() => setShowTerms(false)}>
                  <X size={18} />
                </button>
              </div>

              <h2 className="ad-terms-title">광고 제거 결제 전 확인사항</h2>
              <p className="ad-terms-subtitle">
                전자상거래법 관련 안내, 청약철회 기준, 서비스 종료 특약을 한 번에 확인할 수 있습니다.
              </p>

              <div className="ad-terms-summary-grid">
                <div className="ad-terms-summary-chip">
                  <span>결제 방식</span>
                  <strong>송금 신청</strong>
                </div>
                <div className="ad-terms-summary-chip">
                  <span>이용 기간</span>
                  <strong>서비스 종료시까지</strong>
                </div>
                <div className="ad-terms-summary-chip">
                  <span>문의</span>
                  <strong>wicaduce@gmail.com</strong>
                </div>
              </div>
            </div>

            <div className="ad-terms-body">
              <section className="ad-terms-section">
                <h3>1. 전자상거래법 관련 안내</h3>
                <p>
                  본 서비스는 「전자상거래 등에서의 소비자보호에 관한 법률」 등 관련 법령을 준수합니다.
                  결제 전에는 가격, 제공 방식, 이용 기간, 청약철회 제한 가능성 등 주요 내용을 충분히 확인해 주세요.
                </p>
              </section>

              <section className="ad-terms-section">
                <h3>2. 청약철회 약관</h3>
                <p>
                  결제 후 서비스 이용이 시작되기 전에는 관련 법령이 허용하는 범위 내에서 청약철회를 요청할 수 있습니다.
                  다만 서비스 이용이 이미 개시되었거나, 법령상 청약철회가 제한되는 경우에는 환불이 제한될 수 있습니다.
                </p>
                <ul className="ad-terms-list">
                  <li>결제 완료 후 이용이 개시된 경우에는 청약철회가 제한될 수 있습니다.</li>
                  <li>서비스 특성상 즉시 제공이 시작되면 법령상 환불 예외가 적용될 수 있습니다.</li>
                  <li>환불 가능 여부는 관련 법령과 실제 이용 상태를 기준으로 판단합니다.</li>
                </ul>
              </section>

              <section className="ad-terms-section">
                <h3>3. 특약</h3>
                <p>
                  본 광고 제거 기능은 서비스 종료시까지 제공됩니다.
                  서비스 종료 이후에는 잔여기간이 있더라도 환불이 불가합니다.
                </p>
              </section>

              <section className="ad-terms-section">
                <h3>4. 신청 및 문의</h3>
                <p>
                  입금 메모는 반드시 사용자명으로 작성해 주세요.
                  24시간 이내에 미승인 상태가 지속되면 <strong>wicaduce@gmail.com</strong>으로 문의해 주세요.
                  확인 후 응대해 드리겠습니다.
                </p>
              </section>
            </div>

            <div className="ad-terms-footer">
              <div className="ad-terms-footer-note">
                약관을 모두 확인하셨다면 신청 안내로 돌아가 다음 단계를 진행하세요.
              </div>
              <button type="button" className="btn btn-primary" onClick={() => setShowTerms(false)}>
                확인
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default AdRemovalPage;
